export const support = [
    {
        value: '2',
        label: 'Respite care',
        option: 'A',
        instruction: '',
    },
    {
        value: '3',
        label: 'Careworkers coming in',
        option: 'B',
        instruction: '',
    },
    {
        value: '4',
        label: 'Residential care home',
        option: 'C',
        instruction: '',
    },
    {
        value: '5',
        label: 'Family support',
        option: 'D',
        instruction: '',
    },
    {
        value: '0',
        label: 'I’m not currently receiving any support',
        option: 'E',
        instruction: '',
    },
    {
        value: '1',
        label: 'Other',
        option: 'F',
        instruction: '',
    },
];
